import { render, staticRenderFns } from "./assetsInfo.vue?vue&type=template&id=bc0f9ff0&scoped=true&"
import script from "./assetsInfo.vue?vue&type=script&lang=js&"
export * from "./assetsInfo.vue?vue&type=script&lang=js&"
import style0 from "./assetsInfo.vue?vue&type=style&index=0&id=bc0f9ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0f9ff0",
  null
  
)

export default component.exports